import classnames from "classnames";

import { useMergeClasses } from "../useMergeClasses";

import { zeffyTypographyClasses, StyledTypography } from "./styles";
import { TypographySsrProps } from "./types";

export const DashboardTypographySsr: React.FC<TypographySsrProps> = ({
  classes: externalClasses,
  className,
  vibe,
  forwardedRef,
  ...rest
}) => {
  const classes = useMergeClasses(zeffyTypographyClasses, externalClasses);
  return <StyledTypography {...rest} className={classnames(className, vibe && classes[vibe])} ref={forwardedRef} />;
};

DashboardTypographySsr.displayName = "DashboardTypography";
